function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3-dwdw{fill:#c92941}.cls-4{stroke:none}\r\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "dwf-Rectangle_3523",
  fill: "#fff",
  stroke: "#1b1464",
  strokeWidth: "1.4px"
}, /*#__PURE__*/React.createElement("rect", {
  width: 21.682,
  height: 3.975,
  className: "cls-4",
  rx: 1.988
}), /*#__PURE__*/React.createElement("rect", {
  width: 20.282,
  height: 2.575,
  x: 0.7,
  y: 0.7,
  fill: "none",
  rx: 1.288
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "dwf-Group_4453",
  transform: "translate(1.807 1.988)"
}, /*#__PURE__*/React.createElement("g", {
  id: "dwf-Subtraction_3",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.108 17.37l-1.63-.001c-.078-.159-.181-.305-.31-.433-.302-.304-.705-.471-1.134-.471-.633 0-1.182.369-1.442.903H5.96c-.077-.158-.18-.304-.308-.432-.303-.304-.706-.471-1.135-.471-.633 0-1.182.369-1.443.903H2c-.717 0-1.3-.583-1.3-1.3V.7h16.668v15.369c0 .716-.583 1.3-1.3 1.3h-1.074c-.077-.16-.181-.305-.309-.434-.303-.303-.706-.47-1.134-.47-.633 0-1.182.37-1.443.904z",
  className: "cls-4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1b1464",
  d: "M11.723 16.67c.421-.55 1.084-.905 1.828-.905.616 0 1.194.24 1.63.676.071.072.138.148.199.227h.688c.33 0 .6-.269.6-.6V1.4H1.4v14.669c0 .33.27.6.6.6h.689c.421-.55 1.084-.904 1.828-.904.616 0 1.195.24 1.63.676.072.072.138.148.2.227h.859c.421-.549 1.084-.903 1.828-.903.616 0 1.195.24 1.63.676.072.072.139.148.2.228h.859m.925 1.4H9.937c0-.242-.093-.468-.264-.639-.17-.17-.397-.265-.639-.265-.498 0-.903.405-.903.903H5.42c0-.24-.094-.467-.265-.638-.17-.17-.398-.265-.639-.265-.498 0-.903.405-.903.903H2c-1.103 0-2-.897-2-2V0h18.068v16.069c0 1.102-.897 2-2 2h-1.614c0-.242-.094-.468-.264-.639-.171-.171-.398-.265-.639-.265-.498 0-.903.405-.903.903v.001z"
})), /*#__PURE__*/React.createElement("g", {
  id: "dwf-Group_4455",
  transform: "translate(4.065 3.614)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "dwf-Rectangle_3521",
  width: 9.938,
  height: 1.807,
  className: "cls-3-dwdw",
  rx: 0.903
}), /*#__PURE__*/React.createElement("rect", {
  id: "dwf-Rectangle_3522",
  width: 9.938,
  height: 1.807,
  className: "cls-3-dwdw",
  rx: 0.903,
  transform: "translate(0 3.614)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "dwf-Rectangle_3524",
  width: 5.42,
  height: 1.807,
  className: "cls-3-dwdw",
  rx: 0.903,
  transform: "translate(0 7.227)"
})));

var SvgHBillPayment = function SvgHBillPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dwf-Group_14263",
    width: 21.682,
    height: 20.057,
    viewBox: "0 0 21.682 20.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHBillPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-billPayment.629b6f21.svg";
export { ForwardRef as ReactComponent };